import AssignmentIcon from 'assets/icons/assignment_icon.svg';
import FinishCallIcon from 'assets/icons/finish_call_icon.svg';
import MapIcon from 'assets/icons/map_icon.svg';
import PetPawIcon from 'assets/icons/pet_paw_icon.svg';
import PdfFile from 'assets/icons/pdf_file.svg';
import PdfFilWhite from 'assets/icons/pdf_file_white.svg';

export const Icons = {
  AssignmentIcon,
  FinishCallIcon,
  MapIcon,
  PetPawIcon,
  PdfFile,
  PdfFilWhite
};
